import { convertToValidOpeningHours } from "../../../../../../pages/adapters/pages/adapters/convert-to-valid-opening-hours.js";
import { FRANCHISE_STORE } from "../../../../../../types.js";
const fromStoreQueryDataToStoreDetails = (storeQueryData) => {
  if (!storeQueryData) {
    return null;
  }
  try {
    const {
      code,
      globalStoreId,
      slug,
      name,
      description,
      storenote,
      email,
      storeDetailImage,
      streetName,
      streetNumber,
      additionalStreetInfo,
      postalCode,
      town,
      province,
      country,
      lat,
      lon,
      phone,
      metaDescription,
      servicesNotAvailable,
      features,
      storeFacilities,
      monOpenClose,
      tueOpenClose,
      wedOpenClose,
      thuOpenClose,
      friOpenClose,
      satOpenClose,
      sunOpenClose,
      specialOpenClosingHours,
      offers,
      hearingAppointmentPossible,
      wheelchairAccessible,
      breadcrumbName,
      breadcrumbSlug,
      practicalInformation,
      rating,
      googlePlaceId,
      googlePlaceReviewUrl,
      defaultAppointmentTypeId,
      shortName,
      appointmentsAvailable,
      opticians
    } = storeQueryData;
    const storeTypes = storeQueryData.storeTypes || [];
    return {
      code,
      globalStoreId,
      name,
      streetName,
      town,
      country,
      phone,
      practicalInformation: practicalInformation ?? void 0,
      slug: slug ?? void 0,
      description: description ?? void 0,
      storeNote: storenote ?? void 0,
      detailImage: storeDetailImage ?? void 0,
      streetNumber: streetNumber ?? void 0,
      additionalStreetInfo: additionalStreetInfo ?? void 0,
      postalCode: postalCode ?? void 0,
      province: province ?? void 0,
      wheelchairAccessible: wheelchairAccessible ?? void 0,
      hearingAppointmentPossible: hearingAppointmentPossible ?? void 0,
      lat: lat ?? void 0,
      lon: lon ?? void 0,
      emailAddress: email ?? void 0,
      metaDescription: metaDescription ?? void 0,
      servicesNotAvailable: servicesNotAvailable ?? [],
      breadcrumbName: breadcrumbName ?? void 0,
      breadcrumbSlug: breadcrumbSlug ?? void 0,
      brands: features?.availableBrands ?? [],
      facilities: (storeFacilities ?? []).filter((entry) => entry !== null),
      openingHours: {
        monday: convertToValidOpeningHours(monOpenClose),
        tuesday: convertToValidOpeningHours(tueOpenClose),
        wednesday: convertToValidOpeningHours(wedOpenClose),
        thursday: convertToValidOpeningHours(thuOpenClose),
        friday: convertToValidOpeningHours(friOpenClose),
        saturday: convertToValidOpeningHours(satOpenClose),
        sunday: convertToValidOpeningHours(sunOpenClose)
      },
      specialOpeningHours: (specialOpenClosingHours ?? []).filter(
        (entry) => entry !== null
      ),
      paymentMethods: features?.paymentMethods ?? [],
      socialMediaLinks: features?.socialMediaLinks ?? void 0,
      storeProductCategories: features?.productCategories ?? [],
      offers,
      opticians: (opticians ?? []).map((optician) => ({
        name: optician.name,
        details: optician.details ?? void 0,
        imageUrl: optician.imageUrl ?? void 0
      })),
      rating: rating ? {
        value: rating.value,
        count: rating.count
      } : void 0,
      googlePlaceId: googlePlaceId ?? void 0,
      googlePlaceReviewUrl: googlePlaceReviewUrl ?? void 0,
      defaultAppointmentTypeId: defaultAppointmentTypeId ?? void 0,
      isFranchiseStore: storeTypes.includes(FRANCHISE_STORE),
      shortName,
      appointmentsAvailable
    };
  } catch (e) {
    console.error(
      "Store query data adapter failed to parse input data correctly.",
      e,
      storeQueryData
    );
    return null;
  }
};
export {
  fromStoreQueryDataToStoreDetails as default,
  fromStoreQueryDataToStoreDetails
};
//# sourceMappingURL=fromStoreQueryDataToStoreDetails.js.map
